import React, { useState } from 'react';
import './Contact.css';

const Contact = () => { 

  return (
    <div className="contact-section">
      <h2>Contact Us</h2>
      <div className="contact-container">
        <div className="contact-info">
          <h3>Get in Touch</h3>
          <p>Have a question or want to place an order? Reach out to us!</p>

          <div className="info-item">
            <i className="fas fa-envelope"></i>
            <p>purplehippoprinting@gmail.com</p>
          </div>
          
          <div className="info-item">
            <i className="fas fa-location-dot"></i>
            <p>Bank House, Gisburn, Clitheroe BB7 4HE</p>
          </div>

          <div className="business-hours">
            <h4>Business Hours</h4>
            <p>Monday: 10:00 AM - 4:00 PM</p>
            <p>Tuesday: Closed</p>
            <p>Wednesday: 10:00 AM - 4:00 PM</p>
            <p>Thursday: Closed</p>
            <p>Friday: 10:00 AM - 4:00 PM</p>
            <p>Saturday: Closed</p>
            <p>Sunday: Closed</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact; 